var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Briefcase",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Briefcase",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3a2 2 0 012-2h4a2 2 0 012 2v1h3a1 1 0 011 1v9a1 1 0 01-1 1H1a1 1 0 01-1-1V5a1 1 0 011-1h3V3zm6 0v1H6V3h4zm-8 7v3h12v-3h-4a1 1 0 01-1 1H7a1 1 0 01-1-1H2zm8-2h4V6H2v2h4a1 1 0 011-1h2a1 1 0 011 1z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgJobsIcon;